module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ELECTRICAL-ELECTRONIC ENGINEERING-45b147e0905a97658a02437c9fa19a74.png";